/**
 * 圖文卡的圖示 — 全部取自業主 2026-08-19 交付素材。
 *
 * 素材是整顆按鈕的合成圖（圖示 + 中文字），字不能用——要跟語系與 A/A+/A++ 字級
 * 走，燒成圖就都動不了；所以只裁上半的圖示，文字仍走 i18n。
 *
 * 早先這裡是自繪 SVG（好處是能吃 currentColor）。素材到位後改用真圖：設計稿的
 * 遊艇有海鷗與浪紋、票券上有 FORMOSA 印章，自繪只會做出一個形似而細節全失的
 * 近似品，而這四顆是首頁最主要的視覺。
 */

/** 觸碰開始 — 手指點擊（業主素材 1_06）。 */
export function TouchIcon(): JSX.Element {
  return <img className="k-tile__img" src="/brand/home-touch.png" alt="" aria-hidden="true" />;
}

/** 語音互動 — 麥克風加音波（業主素材 1_07）。 */
export function MicIcon(): JSX.Element {
  return <img className="k-tile__img" src="/brand/home-mic.png" alt="" aria-hidden="true" />;
}

/** 行程推薦 — 讚（業主素材 2_05）。 */
export function ThumbIcon(): JSX.Element {
  return <img className="k-tile__img" src="/brand/menu-recommend.png" alt="" aria-hidden="true" />;
}

/** 搭船遊港 — 遊艇（業主素材 2_06）。 */
export function YachtIcon(): JSX.Element {
  return <img className="k-tile__img" src="/brand/menu-cruise.png" alt="" aria-hidden="true" />;
}

/** 水上設施 — SUP（業主素材 2_07）。 */
export function SupIcon(): JSX.Element {
  return <img className="k-tile__img" src="/brand/menu-water.png" alt="" aria-hidden="true" />;
}

/** 查詢票券 — 票券與放大鏡（業主素材 2_08）。 */
export function TicketIcon(): JSX.Element {
  return <img className="k-tile__img" src="/brand/menu-ticket.png" alt="" aria-hidden="true" />;
}
